// import { getStackComponentListAction } from './getStackComponentListAction';
// import { getStackComponentByIdAction } from './getStackComponentByIdAction';
// import { getAllRunsByStackComponentId } from './getAllRunsByStackComponentId';
import { getFlavorAllAction } from './getFlavorAllAction';
import { getFlavorTypeAction } from './getFlavorTypeAction';

export const flavorsActions = {
  getAll: getFlavorAllAction,
  getType: getFlavorTypeAction,
};
